import React from 'react';
import { Outlet } from 'react-router-dom';
import ChatLayout from '../chat-platform/ChatLayout';
import { isAuthenticated } from '../utils/api';

const ChatAssistantRoute = () => {
    if (isAuthenticated()) {
        return (
            <ChatLayout />
        );
    }
    return (
        <div className='flex flex-1 w-full h-full'>
            <Outlet />
        </div>
    );
};

export default ChatAssistantRoute;
